export enum MediaBreakPoints { // styles/_variables.scss
  DESKTOP = 1024, // Основной брейкпоинт: мобильная верстка до 1024px, дальше ноутбуки/десктоп
  TABLET = 930,
  MOBILE_LARGE = 720,
  MOBILE_MEDIUM = 560,
  MOBILE_SMALL = 460,
}

export enum FormNames {
  PHONE = "input-phone",
  CODE = "input-code",
  PASSWORD = "input-password",
  PASSWORD_APPLY = "password-apply",
  MESSAGE = "confirm-message",
  ERROR_PHONE = "error-phone-not-found",
  ERROR_CODE = "error-bad-code",
  ERROR = "error",
}

export enum WindowNames {
  AUTH = "auth",
  AUTH_ERROR = "authError",
  APP_INFO = "appInfo",
  FORGOT_PASS = "forgotPass",
  REGISTRATION = "register",
  REGISTRATION_SUCCESS = "regSuccess",
  ERROR = "error",
  CODE = "code",
  ERROR_CODE = "error-bad-code",
}

export const appController = {
  DISABLE_NEXT_MONTH_DATES: false,
  AFK_TIMER_MINUTES: 15,
};
